<template>
	<div id="app">
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive">
				<!-- 被缓存数据的视图组件 -->
			</router-view>
		</keep-alive>

		<router-view v-if="!$route.meta.keepAlive">
			<!--不被缓存数据的视图组件-->
		</router-view>
		
	</div>
</template>

<script>

export default {
	name: 'app',
	created(){
	}
}
</script>

<style>
	html,
	body {
		height: 100%;
	}
	
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		height: 100%;
	}
	
	.main-container {
		padding: 15px;
	}
    .btn-secondary.disabled, .btn-secondary:disabled {
    color: #fff;
    background-color: #6F6F6F!important;
    border-color: #6F6F6F!important;
    }

</style>
